import measureService from "@/services/akeneo/measure";
import regionService from "@/services/serli/region";
import { locales } from '@/common/localesList'
import _ from "lodash";
import axios from "axios";
import {SERLI_API_URL,SALESBOX_API_URL} from "@/common/config";
import productService from "@/services/serli/product";
import salesboxService from "@/services/salesbox/api";

const initialState = {
    brand: 'manitou',
    locale: 'en_US',
    country: 'FR',
    countries:[],
    region: 'R1',
    unitType: 'metric',
    measures: null,
    homepageVisitCount: 0,
    lastSentFeedbackDate: null,
    selectLanguageFromSelectList: false,
    measuresFetchDate: null,
    isLargeDesktop: false,
    isSmallDesktop: false,
    isMobile: false,
    isTablet: false,
    isPhone: false,
    isPortrait: false,
    displayTopConfiguration: false,
    navigationItems: [],
    markets: null,
    applications: null,
    categories: null,
    asyncCategories:null,
    machine_experiences:null,
    onBoarding: {onboard: [], new: []},
    news: null,
    firstConnexion: true,
    lastVisit : null,
    newsTimer: null,
    sinceClickNews : false,
    showNews : false,
};

export const state = { ...initialState };

export default {
    namespaced: true,
    state,
    getters: {
        localeKebabFormat: (state) => {
            return _.replace(state.locale, '_', '-');
        }
    },
    mutations: {
        reset (state) {
            const s = initialState;
            Object.keys(s).forEach(key => state[key] = s[key])
        },
        setMeasures(state, value) {
            state.measures = value;
        },
        setMeasuresFetchDate(state, value) {
            state.measuresFetchDate = value;
        },
        setHomepageVisitCount(state, value) {
            state.homepageVisitCount = value;
        },
        setLanguageFromSelectList(state, value) {
            state.selectLanguageFromSelectList = value;
        },
        incrementHomepageVisitCount(state) {
            state.homepageVisitCount++
        },
        updateLastSentFeedbackDate(state) {
            state.lastSentFeedbackDate = new Date().toISOString().slice(0,10);
        },
        setBrand(state, value) {
            state.brand = value;
        },
        setLocale(state, value) {
            state.locale = value;
        },
        setCountry(state, value) {
            state.country = value.substr(value.length - 2);
        },
        setCountries(state, value) {
            state.countries = value;
        },
        setRegion(state, value) {
            state.region = value;
        },
        setUnitType(state, unitType) {
            state.unitType = unitType;
        },
        setIsLargeDesktop(state, value) {
            state.isLargeDesktop = value;
        },
        setIsSmallDesktop(state, value) {
            state.isSmallDesktop = value;
        },
        setIsMobile(state, value) {
            state.isMobile = value;
        },
        setIsTablet(state, value) {
            state.isTablet = value;
        },
        setIsPhone(state, value) {
            state.isPhone = value;
        },
        setIsPortrait(state, value) {
            state.isPortrait = value;
        },
        setDisplayTopConfiguration(state, value) {
            state.displayTopConfiguration = value;
        },
        toggleDisplayTopConfiguration(state) {
            state.displayTopConfiguration = !state.displayTopConfiguration;
        },
        setNavigationItems(state, value) {
            state.navigationItems = value;
        },
        setMarkets(state,datas) {
            state.markets=datas;
        },
        setApplications(state,datas) {
            state.applications=datas;
        },
        setCategories(state,datas) {
            state.categories=datas;
        },
        setAsyncCategories(state,datas) {
            state.asyncCategories=datas;
        },
        setMachineExperiences(state,datas) {
            state.machine_experiences=datas;
        },
        setOnBoarding(state, datas) {
            state.onBoarding['onboard']=datas.onboard;
            if (datas.new.length > state.onBoarding['new'].length) state.newsTimer = new Date()
            state.onBoarding['new']=datas.new;
        },
        setFirstConnexion(state, value) {
            state.firstConnexion = value;
        },
        setLastVisit(state, value) {
            state.lastVisit = value;
        },
        setSinceClickNews(state, value) {
            state.sinceClickNews = value;
        },
        setShowNews(state, value) {
            state.showNews = value;
        },
    },
    actions: {
        deviceDetection(context, windowWidth) {
            context.commit('setIsLargeDesktop', (windowWidth <= 1400 && windowWidth > 1280));
            context.commit('setIsSmallDesktop', (windowWidth <= 1280 && windowWidth > 1024));
            context.commit('setIsMobile', (windowWidth <= 1024));
            context.commit('setIsTablet', (windowWidth <= 1024 && windowWidth > 768));
            context.commit('setIsPhone', (windowWidth <= 768));
        },
        deviceOrientation(context, orientation) {
            context.commit('setIsPortrait', (orientation == 0));
        },
        navigatorDetectLanguage(context, navigatorLang) {
            // On détecte la langue de l'usager pour l'utiliser
            let navigatorLanguage = navigatorLang.replace('-', '_');
            if(navigatorLanguage.indexOf('_') !== -1) {
                navigatorLanguage = navigatorLanguage.split('_');
                navigatorLanguage = navigatorLanguage[0] + '_' + navigatorLanguage[1].toUpperCase();
            } else {
                navigatorLanguage = navigatorLanguage + '_' + navigatorLanguage.toUpperCase();
            }
            let selectLang = 'en_US';
            locales.forEach((language) => { if(language.code === navigatorLanguage) selectLang = navigatorLanguage; });
            context.commit('setLocale', selectLang);
            context.commit('setLanguageFromSelectList', true);
        },
        fetchMeasures({ commit }) {
           return measureService.list().then(response => {
               commit('setMeasures', response.data.data);
               commit('setMeasuresFetchDate', Date.now());
               return response.data.data;
           })
        },
        async setCountryAndRelatedRegion({ commit }, country) {
            commit('setCountry', country);
            const regions = await regionService.list()
            let currentCountryRegion = regions[country];
            commit('setRegion', currentCountryRegion);
        },

        // async loadOnboard({ commit, state }) {
        //     var locale=_.replace(state.locale, '_', '-');
        //     //OnBoarding
        //     await axios.get(`${SALESBOX_API_URL}onboarding/${locale}/list`).then(async (response) => {
        //         commit('setOnBoarding',response.data);
        //     })
        // },

        async loadCommonDatas({ commit,state }) {
            var locale=_.replace(state.locale, '_', '-');

            await salesboxService.get(`${SALESBOX_API_URL}onboarding/${state.locale}/list?region=${state.region}`).then(async (response) => {
                commit('setOnBoarding',response.data);
            })

            //Infos de markets
            await salesboxService.get(`${SERLI_API_URL}countries`).then(async (response) => {
                commit('setCountries',response.data.data);
                if (state.country.indexOf('GG_COUNTRY_') !== -1) {
                    commit('setCountry', state.country.slice(-2))
                }
            })

            //Infos de markets
            await salesboxService.get(`${SERLI_API_URL}markets?locale=${locale}&brand=manitou`).then(async (response) => {
                commit('setMarkets',response.data.data);
            })
            //Infos d'applications
            await salesboxService.get(`${SERLI_API_URL}applications?locale=${locale}&brand=manitou`).then(async (response) => {
                commit('setApplications',response.data.data);
            })
            //Infos de catégories
            await salesboxService.get(`${SERLI_API_URL}categories?locale=${locale}&brand=manitou`).then(async (response) => {
                commit('setCategories',response.data.data);
            })

            await productService.categories({
                locale: locale,
                brand: state.brand,
                unit: state.unitType
            })
            .then(response => {
                commit('setAsyncCategories',response.data.data.children);

            })

            //Infos d'xp immersive
            await salesboxService.get(`${SALESBOX_API_URL}experience/${locale}/list`).then(async (response) => {
                commit('setMachineExperiences',response.data);
            })
        }
    }
};
